<template>
  <div class="plan-name-box">
    <b class="contract-number">{{ contractId }} -</b>
    <div class="editable">
      <input
        v-if="editing"
        name="name"
        class="form-control plan-label-input"
        v-model="newValue"
      />
      <div class="plan-name-box-edit" v-on:click="edit">
        <div
          v-if="!editing"
          class="edit-header"
          data-toggle="tooltip"
          title="Editar o nome do plano"
        >
          {{ newValue }}
        </div>
      </div>
      <p class="balance-box" v-if="currentBalance">
        <span>Saldo:&nbsp;</span>
        <span class="bold" :class="currentBalance >= 0 ? 'green' : 'red'">{{
          currentBalance | cents
        }}</span>
      </p>
      <div
        class="inline"
        data-toggle="tooltip"
        title="Cancelar edição"
        v-on:click="cancel"
      >
        <i v-if="editing && !loading" class="icon-cancel-edit"></i>
      </div>
      <div
        class="inline"
        data-toggle="tooltip"
        title="Salvar edição"
        v-on:click="confirm"
      >
        <i v-if="editing && !loading" class="icon-check-edit"></i>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.editable {
  width: calc(100% - 60px);
  /* width: calc(100% - 90px); */
}
</style>
<script>
import { cents } from "../../filters/number";
import Contracts from "../../services/contracts";

export default {
  props: ["contractId", "contractName", "planId", "currentBalance"],
  data() {
    return {
      newValue: this.contractName,
      editing: false,
      loading: false,
    };
    $('[data-toggle="tooltip"]').tooltip("show");
  },

  mounted() {
    $('[data-toggle="tooltip"]').tooltip();
  },
  computed: {},
  methods: {
    edit() {
      this.editing = true;
      $('[data-toggle="tooltip"]').tooltip("hide");
      $(".plan-name-box-edit").this().addClass("hidden");
    },
    cancel() {
      this.editing = false;
      this.newValue = this.contractName;
      $('[data-toggle="tooltip"]').tooltip("hide");
      $(".plan-name-box-edit").removeClass("hidden");
    },
    confirm() {
      this.loading = true;
      $('[data-toggle="tooltip"]').tooltip("hide");
      $(".plan-name-box-edit").removeClass("hidden");
      Contracts.updateContractName(this.contractId, this.newValue)
        .then((res) => {
          this.editing = false;
          this.loading = false;
          this.$emit("input", this.newValue);
        })
        .catch((err) => {
          this.loading = false;
          $('[data-toggle="tooltip"]').tooltip("hide");
          $(".plan-name-box-edit").removeClass("hidden");
          let msg =
            (err.data && err.data.status && err.data.status.message) ||
            "Erro do servidor.";
          messageDialog.show({
            title: "Erro",
            headerClass: "modal-danger",
            message: msg,
          });
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// contract-name.vue?7a2307e9